import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import styles from './ChecklistModal.module.css';
import {
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';
import { ArrowBack } from 'components/icons';

function ChecklistAssignedPatrolInfo({ patrols = [], handler }) {
	const { onCancel = null, onBack = null } = handler || {};
	return (
		<Modal
			open={true}
			onClose={onCancel}
			aria-labelledby="draggable-dialog-title"
			style={{
				justifyContent: 'center',
				alignItems: 'center',
				display: 'flex',
			}}
		>
			<Box
				className={styles.modal_wrapper}
				sx={{
					width: '80%',
					maxHeight: '80%',
					bgcolor: 'background.paper',
					p: 2,
					overflowY: 'scroll',
				}}
			>
				<div style={{ display: 'flex' }}>
					<IconButton onClick={onBack}>
						<ArrowBack color="primary" />
					</IconButton>
					<Typography
						style={{
							marginLeft: '1rem',
							fontSize: '1.5rem',
							display: 'inline-block',
						}}
					>
						This checklist is assigned to {patrols.length}{' '}
						patrol(s):
					</Typography>
				</div>

				<Typography>
					<TableContainer>
						<Table size={'small'} stickyHeader>
							<TableHead>
								<TableRow>
									<TableCell align="left">
										Start Time
									</TableCell>
									<TableCell align="left">Customer</TableCell>
									<TableCell align="left">Address</TableCell>
									<TableCell align="left">Guard</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{patrols?.map((patrol, index) => {
									return (
										<TableRow key={index}>
											<TableCell align="left">
												{patrol?.start_time}
											</TableCell>
											<TableCell align="left">
												{patrol?.customer}
											</TableCell>
											<TableCell align="left">
												{patrol?.address}
											</TableCell>
											<TableCell align="left">
												{patrol?.name}
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
				</Typography>
				<Divider />
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						padding: '1rem',
					}}
				>
					<Button variant="outlined" size="small" onClick={onCancel}>
						close
					</Button>
				</div>
			</Box>
		</Modal>
	);
}

export default ChecklistAssignedPatrolInfo;
